import { FooterMenuGroup } from '@v2/shared/Layouts/Full/Footer/FooterMenu';
import { openConsentPreferences, useConsentLawActive } from '@v2/shared/lib/cookieYes';

/**
 * MagZoom's footer, as data — the two columns of
 * `domain-overrides/magzoom.com/layouts/full/footer.html`, in its order and with its
 * wording.
 *
 * Its own module for the same reason MagSpot's is: the columns are shared and only the
 * list is the brand's. Paths are relative and go through `buildUrl` on the way out. A
 * hook rather than a constant for the same reason too — one entry is conditional.
 *
 * Deliberately not MagSpot's list with the names changed. MagZoom's footer offers three
 * policies where MagSpot's offers five, and spells two of the three entries differently
 * — "Frequently Asked Questions" rather than "FAQ", "Policies" rather than "Legal".
 */
export default function useFooterMenu(): FooterMenuGroup[] {
  const consentLawActive = useConsentLawActive();

  return [
    {
      title: 'About',
      items: [
        { label: 'About Us', href: '/about-us' },
        { label: 'Frequently Asked Questions', href: '/help' },
        { label: 'Contact Us', href: '/contact' },
      ],
    },
    {
      title: 'Policies',
      items: [
        { label: 'Terms of Use', href: '/terms' },
        { label: 'Privacy Policy', href: '/privacy' },
        // Only where CookieYes says a privacy law applies — see useConsentLawActive. The
        // title is Cal. Civ. Code 1798.135(a)(1)'s wording, not MagZoom's, and
        // deliberately so: every brand spells it identically. The click opens the
        // preference centre; the href is where it lands if CookieYes cannot be asked.
        ...(consentLawActive
          ? [
              {
                label: 'Do Not Sell or Share My Personal Information',
                href: '/privacy#your-choices',
                onClick: openConsentPreferences,
              },
            ]
          : []),
        { label: 'Accessibility', href: '/accessibility' },
      ],
    },
  ];
}
